declare global {
	interface Window {
		turner_metadata: {
			trackAction: {
				type: string,
				data: {}
			}[]
		};
	}
}

const container = (function () {

	return {
		/*
		 * Show message in console
		 * @param String msg - message to show
		 */
		msg: function (name: string, msg: string) {
			if (typeof console === 'object' && typeof console.info === 'function') {
				console.info(name + ' - ' + msg);
			}
		},
		errorMsg: function (name: string, msg: string) {
			if (typeof console === 'object' && typeof console.error === 'function') {
				console.error(name + ' - ' + msg);
			}
		},

		/*
 * Track page for statistics
 * @param String id - string of something that should be measured
 */
		trackPageView: function (values: {
			pageName: string,
			page_name?: string,
			content_title?: string,
			trackAdd?: {}
		}) {
			try {
				if (!('turner_metadata_data' in window) || typeof window['turner_metadata_data'] !== 'object') {
					return;
				}

				if (!('turner_metadata' in window) || typeof window['turner_metadata'] !== 'object') {
					return;
				}

				const data = { ...window['turner_metadata_data'], ...values };

				window['turner_metadata'].trackAction.push({
					'type': 'pageview',
					'data': data
				});
				
				container.msg('stats', 'pageview pageName ' + data.pageName);
			} catch (e) {
				console.log(e);
			}
		},
		trackInteraction: function (interaction: string, values: {
			pageName: string,
			page_name?: string,
			content_title?: string,
			trackAdd?: {}
		}) {
			try {
				if (!('turner_metadata_data' in window) || typeof window['turner_metadata_data'] !== 'object') {
					return;
				}

				if (!('turner_metadata' in window) || typeof window['turner_metadata'] !== 'object') {
					return;
				}

				const data = { ...window['turner_metadata_data'], 'interaction': interaction, ...values };

				window['turner_metadata'].trackAction.push({
					'type': 'interaction',
					'data': data
				});

				container.msg('stats', 'interaction pageName ' + data.pageName + ' interaction: ' + interaction);
			} catch (e) {
				console.log(e);
			}
		},

	};
})();

export default container;